import { render, staticRenderFns } from "./StockInventoryTaskBody.vue?vue&type=template&id=7fabcdce&"
import script from "./StockInventoryTaskBody.vue?vue&type=script&lang=js&"
export * from "./StockInventoryTaskBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QSeparator,QBtn,QItem,QInput,QIcon,QTooltip,QField,QCheckbox,QExpansionItem} from 'quasar'
component.options.components = Object.assign({QCardSection,QSeparator,QBtn,QItem,QInput,QIcon,QTooltip,QField,QCheckbox,QExpansionItem}, component.options.components || {})
